export const UPDATE_POPUP_PLAYER = 'UPDATE_POPUP_PLAYER';
export const CLOSE_POPOUT_PLAYERS = 'CLOSE_POPOUT_PLAYERS';
export const POPUP_PLAYER_READY = 'POPUP_PLAYER_READY';
export const UPDATE_PREMIUM_STATUS = 'UPDATE_PREMIUM_STATUS';
